import ApiService from "@/services/api.service";

const actions = {
  fetchVirtualDepartments({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getvirtualdepartments/", { ...payload })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchPersonnelPlanningByYearDepartment({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post(
        "getpersonnelplannings/get-personnel-planning-by-year-and-department/",
        { ...payload },
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
};

export default {
  namespaced: true,
  actions,
};
